// extracted by mini-css-extract-plugin
export default {"layout":"ShopAddons_layout__-igGs","fullView":"ShopAddons_fullView__p7zMw","shimmer":"ShopAddons_shimmer__YeAxn"};